export const fillingOrderTypes = {
  FILLING_ORDER_INPUTS: 'FILLING_ORDER_INPUTS',
  GET_FILLING_ORDERS: 'GET_FILLING_ORDERS',
  DELETE_FILLING_ORDERS: 'DELETE_FILLING_ORDERS',
  FILLING_ORDER_DESELECT_PENDING: 'FILLING_ORDER_DESELECT_PENDING',
  FILLING_ORDER_SELECT_PENDING: 'FILLING_ORDER_SELECT_PENDING',
  FILLING_ORDER_SELECT: 'FILLING_ORDER_SELECT',
  FILLING_ORDER_DESELECT: 'FILLING_ORDER_DESELECT',
}